export default "__VITE_ASSET__DKFjja5___"